<h1 mat-dialog-title>Enviar correo</h1>
<div mat-dialog-content>
  <p>¿Desea enviar correo electrónico al cliente?</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Enviar</button>
</div>
